import { SvgIcon, SvgIconProps } from '@mui/material';

export const ChevronLeft = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M14.53 5.47c.3.3.3.77 0 1.06L9.66 11.4a8.3 8.3 0 0 0-.48.53.25.25 0 0 0 0 .14l.07.1c.08.1.2.22.41.43l4.87 4.87a.75.75 0 1 1-1.06 1.06L8.6 13.66l-.02-.02c-.18-.18-.35-.35-.48-.5a1.77 1.77 0 0 1-.35-.6 1.75 1.75 0 0 1 0-1.08c.08-.25.22-.44.35-.6.13-.15.3-.32.48-.5l.02-.02 4.87-4.87c.3-.3.77-.3 1.06 0Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};
